import React ,{useEffect, useState} from "react";

const Brands =(props)=>{
    const [show, setShow] = useState(false);
    const [showBox, setShowBox] = useState(true);
    useEffect(()=>{
        setShow(false);
        setShowBox(true);
    },[])
    
   if(props.Data?.length>0){
    return(
        <div className="p-0 mb-3">
            <div className="row box-title p-0 m-0">
                <div className="col-9"><span >Thương hiệu</span></div>
                <div className="col-3 text-right" onClick={()=>setShowBox(!showBox)}><i className={showBox?"bi bi-chevron-up fs-6":"bi bi-chevron-down fs-6"}></i></div>
            </div>
            {
                showBox ?(
                    <>
                    <ul className="p-0 mt-2 custom-scroll">
                        {
                            show ? (
                                props.Data?.map((item, index)=>{
                                return <li key={index} className="py-2 ms-2 d-flex">
                                            <input aria-label={item.url_key} onClick={()=>props.parentCallback(item)} type="checkbox" name={"thuong_hieu_"+item.url_key} className="me-2" id={item.url_key}/>
                                            <div className="d-flex justify-content-between w-100 px-2"><label className="text-brand" for={item.url_key}>{item.name}</label> 
                                            <span className="fs-12 text-gray-300">({item.count})</span></div>
                                    </li>
                            })
                            ):(
                                props.Data?.slice(0,5).map((item, index)=>{
                                return <li key={index} className="py-2 ms-2 d-flex">
                                            <input aria-label={item.url_key} onClick={()=>props.parentCallback(item)} type="checkbox" name={"thuong_hieu_"+item.url_key} className="me-2" id={item.url_key}/>
                                            <div className="d-flex justify-content-between w-100 px-2">
                                                <label className="text-brand" for={"thuong_hieu_"+item.url_key}>{item.name}</label> 
                                            <span className="fs-12 text-gray-300">({item.count})</span></div>
                                    </li>
                            })
                            )
                        }
                    </ul>
                    {
                        props.Data.length > 4 ?(<div className="text-center mb-2" onClick={() => setShow(!show)}>
                        <i className={show?"bi bi-chevron-up me-1":"bi bi-chevron-down me-1"}></i>
                    </div>):(null)
                    }
                    </>
                ):(null)
            }
            
        </div>
    )
   }else{return null}
    
}

export default Brands;